export const text = {
  verification: "Verification",
  verificationDescription:
    " Please enter the verification code received on your  email..",
  submit: " Verify",
  resend: "Resend Code",
};
